
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mtn-privacy-policy",
      function () {
        return require("private-next-pages/mtn-privacy-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mtn-privacy-policy"])
      });
    }
  